import { html, css, unsafeCSS } from 'lit';
import { downArrow, clock, svgToDataURL } from './icons';
export const accessibility = css `
    .screen-reader-text {
        border: 0;
        clip: rect(1px, 1px, 1px, 1px);
        clip-path: inset(50%);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute !important;
        width: 1px;
        word-wrap: normal !important; // Many screen reader and browser combinations announce broken words as they would appear visually.
    }
    .screen-reader-text:focus {
		background-color: $color__background-screen;
		border-radius: 3px;
		box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.6);
		clip: auto !important;
		clip-path: none;
		color: $color__text-screen;
		display: block;
		font-size: 0.875rem;
		font-weight: 700;
		height: auto;
		left: 5px;
		line-height: normal;
		padding: 15px 23px 14px;
		text-decoration: none;
		top: 5px;
		width: auto;
		z-index: 100000; // Above WP toolbar.
	}
    :has(>.alt_block){
        position: relative;
	    display: block;
    }
`;
export const formStyles = css `
    :host {
        font-family:var(--allin-font-family,inherit);
        font-size:var(--allin-font-size,1rem);
        color:var(--allin-text-color,#000);
        background-color:var(--allin-bg-color,transparent);
        padding:var(--allin-padding,0);
        font-weight:var(--allin-font-weight,normal);
    }
    form{
        display:flex;
        flex-direction:column;
        gap:1rem;
        position:relative;
    }
    p{
        margin-top:0;
    }
    form.loading::after,.preview_section.loading::after,.loading .searchboxes::after{
        content:'';
        position:fixed;
        top:calc(50% - 1rem);
        left:calc(50% - 1rem);
        width:2rem;
        height:2rem;
        background-image:url(/wp-content/themes/ace/assets/wheel.svg);
        z-index:100;
        background-size: cover;
        animation:spin 1s linear infinite;
    }
    @keyframes spin{
        from{
            transform:rotate(0deg);
        }
        to{
            transform:rotate(-360deg);
        }
    }
    textarea,input{
        font-family:var(--allin-font-family,'Montserrat');

    }
    textarea{
        height:10rem;
    }
    input[type=email],input[type=time],input[type=password],input[type=text],input[type=email],input[type=password],input[type=tel],input[type=number],input[type=tel],input[type=url],textarea, select{
        width:100%;
        padding:1rem;
        border:1px solid var(--allin-border-color,#707070);
        border-radius:var(--allin-border-radius,0.5rem);
        background-color:var(--color-white);
        box-sizing: border-box;
        font-family:var(--allin-font-family,'Montserrat');

    }

    label{
        font-weight:bold;
        display:block;
        width:100%;
    }



    input[type=submit], button, .button{
        padding:1rem;
        border-radius:var(--allin-border-radius,0.5rem);
        font-family:var(--allin-font-family,'Montserrat');
        background-color:var(--allin-button-bg-color,#472961);
        font-size:var(--allin-button-font-size,1rem);
        color:var(--allin-button-text-color,#fff);
        font-weight:(var(--allin-button-font-weight,600));
        cursor:pointer;
        border:none;
        text-decoration:none;
        transition:background-color var(--transition) ease;
        &[disabled]{
            opacity:0.7;
            cursor: not-allowed;
        }
    }
    input[type=submit]:hover, button:hover, .button:hover {
        background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
        font-weight:(var(--allin-button-font-weight,600));
        color: #343434;
    }

    input:read-only:not([type=submit]){
        background-color:#ccc;
        border:none;
        font-weight:700;
    }

    .input-group,::slotted(.input-group){
        display:flex;
        flex-direction:column;
        gap:0.5rem;
        margin-bottom:1rem;
    }


    .input-group:has(>input[type=checkbox],>input[type=radio]){
        display: grid;
        grid-template-columns: 1.2rem 1fr;
    }

    .input-group.check-group-reverse:has(>input[type=checkbox],>input[type=radio]),
    .input-group:has(>input[type=checkbox]:nth-child(2),>input[type=radio]:nth-child(2)){
        grid-template-columns: 1fr 1.2rem;
    }
    .input-group:has(>input[type=checkbox],>input[type=radio]) label{
        flex-basis:fit-content;
    }
    .input-group:has(>input[type=checkbox].error,>input[type=radio].error){
        outline:1px solid #BD2323;
        outline-offset:1rem;
    }

    .input-group:has(>input[type=checkbox],>input[type=radio]) .error_message{
        flex-basis:100%;
        grid-column:span 2;
    }


    .pword_wrapper{
        position:relative;
        margin-bottom:2rem;
    }

    .show-password{
        position:absolute;
        right:1rem;
        top:calc(100% + 0.5rem);
        background-color:transparent;
        border:none;
        cursor:pointer;
        width:fit-content;
        height:2rem;
        border:none;
        padding:0 0.25rem;
        display:flex;
        align-items:center;
        gap:0.5rem;
        color:var(--color-black);
    }
    @media (min-width:700px){
        .pword_wrapper{
            margin-bototm:0;
        }
        .show-password{
            top:0.5rem;
        }
    }

    .show-password svg{
        width:2rem;
        height:2rem;
    }

    .show-password svg path{
        fill:var(--allin-highlight-color,#000);
        transition:fill var(--transition) ease;
    }
    .show-password:hover{
        background-color: var(--color-secondary-to-secondary-lighter);
        color:var(--color-white-to-black);
    }
    .show-password:hover svg path{
        fill:var(--color-white-to-black);
    }

    .hide{
        display:none;
    }

    .hp{
        display:none;
    }

    .error_message{
        color:#BD2323;
        font-size:0.875rem;
        margin-bottom:1rem;
    }

    input.error{
        border:2px solid #BD2323;
    }

    .error{
        color:#BD2323;
    }

    .error a{
        color:#BD2323;
    }

    input[type=checkbox], input[type=radio]{
        accent-color:var(--allin-highlight-color,#472961);
        transform:scale(1.6);
    }

    .input-group .hidden, .input-group.hidden {
        display: none;
        max-height:0;
        overflow:hidden;
        transition:all var(--transition) ease;
        transition-behavior: allow-discrete;
        width:100%;
        margin-top:1rem;
    }
    .image-uploader:has(img[src='']){
        display:none;
    }

    .image-uploader {
        display: flex;
        align-items: start;
        gap: 1rem;
    }

    .image-uploader button {
        background-color: transparent;
        margin-top: 0.5rem;
        padding: 0;
    }

    .image-uploader button svg path {
        fill: black;
    }

    label:has(+allin-repeater){
        padding-bottom:0.5rem;
        border-bottom:1px solid var(--allin-border-color,#707070);
        margin-bottom:1rem;
    }
    .repeater .group{
        border-bottom:1px solid var(--allin-border-color,#707070);
        padding-bottom:1rem;
        margin-bottom:1rem;
        display:grid;
        gap:1rem;
        grid-template-columns: 1fr;
        &.panel{
            border-bottom:none;
            padding-bottom:0;
        }
    }

    .repeater_details{
        border-bottom:1px solid var(--allin-border-color,#707070);
        padding-bottom:1rem;
        margin-bottom:1rem;
    }

    @media screen and (min-width:700px){
        .repeater .group{
            grid-template-columns: 1fr 1fr;
        }

        .repeater .group  .input_group:has(input[type=url]),
        .repeater .group  .input_group:has(select),
        .repeater .provisions{
            grid-column:span 2;
        }
        .add_row,.repeater .button_secondary{
            grid-column: -2/-1;
        }
    }

    .add_row,.repeater .button_secondary{
        background-color: transparent;
        display:block;
        margin-left:auto;
        margin-top:1rem;
        border:none;
        color:var(--allin-highlight-color,#472961);
        display:flex;
        align-items:center;
        justify-content:center;
        gap:0.5rem;
        &:hover{
            text-decoration:underline;
            background-color: transparent;
        }
    }

    

    .datetime_wrapper{
        position:relative;
    }

    .datetime_wrapper svg{
        position:absolute;
        right:0.5rem;
        top:50%;
        transform:translateY(-50%);
        width:1.5rem;
        height:1.5rem;
        cursor:default;
    }

    .datetime_wrapper input[readonly],.flatpickr-input.flatpickr-mobile{
        width: 100%;
        padding: 1rem;
        border: 1px solid var(--allin-border-color, #707070);
        border-radius: var(--allin-border-radius, 0.5rem);
        background-color: var(--allin-input-bg-color, #fff);
        box-sizing: border-box;
        font-family: var(--allin-font-family, 'Montserrat');
        background-color: transparent !important;
        position: relative;
        z-index: 1;
        cursor: pointer;
    }

    .datetime_wrapper:has(.flatpickr-mobile) svg{
        display:none;
    }
    
    lit-flatpickr{
        width:100%;
        border-radius: var(--allin-border-radius, 0.5rem);
    }
  

    .flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay{
        background-color:var(--allin-highlight-color,#472961);
    }
    .white-divider{
        position:relative;
    }
    .white-divider::after{
        content:'';
        position:absolute;
        top:100%;
        left:0;
        width:100%;
        height:2rem;
        background-color:var(--color-bg);
    }
    .white-divider+.input-group{
        margin-top:3rem;
    }
`;
export const grid = css `
    .grid {
        display: grid;
    }
    @media (min-width: 1000px) {
        .grid_25{
            grid-template-columns: repeat(4,1fr);
        }
        .grid_50{
            grid-template-columns: 1fr 1fr;
        }
        .grid_33{
            grid-template-columns: 1fr 1fr 1fr;
        }
        .two_column{
            grid-template-columns: 3fr 1fr;
        }
    }

    .flex{
        display:flex;
    }
    .gap{
        gap:1rem;
    }
    .gap_2{
        gap:2rem;
    }
    .gap_3{
        gap:3rem;
    }
    .gap_4{
        gap:4rem;
    }
    .center{
        justify-content:center;
        align-items:center;
    }
    .space-between{
        justify-content:space-between;
    }
<<<<<<< HEAD
    .align-center{
        align-items:center;
    }
=======
<<<<<<< HEAD
=======
    .align-center{
        align-items:center;
    }
>>>>>>> Event-Listing
>>>>>>> main
    .wrap{
        flex-wrap:wrap;
    }
`;
export const dialog = css `
        ::backdrop {
            background-color: rgba(0, 0, 0, 0.5);
        }
        dialog[open] {
            opacity: 1;
        }
        dialog {
            opacity:0;
            transition:opacity var(--transition) ease;
            width:680px;
            max-width:95vw;
            border:none;
            padding:6rem 2rem 2rem;
            border-radius:1rem;
            box-sizing:border-box;
        }
        dialog .close{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            position:absolute;
            top:2rem;
            right:2rem;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        @starting-style{
            dialog[open]{
                opacity:0;
            }
        }
        dialog.loading{
            pointer-events:none;
            &::after{
                content:'';
                position:absolute;
                width:100%;
                height:100%;
                top:0;
                left:0;
                background-color: rgba(255, 255, 255, 0.5);
            }
            &::before{
                content:'';
                position:fixed;
                z-index:100;
                top:calc(50% - 1rem);
                left:calc(50% - 1rem);
                width:2rem;
                height:2rem;
                background-image:url(/wp-content/themes/ace/assets/wheel.svg);
                z-index:100;
                background-size: cover;
                animation:spinner 1s linear infinite;
            }
        }
        @keyframes spinner{
            from{
                transform:rotate(0deg);
            }
            to{
                transform:rotate(-360deg);
            }
        }
`;
export const details = css `
details {
	padding: 1rem 0;
	border-top:1px solid $color-secondary;
}
details > summary {
    list-style: none;
    position: relative;
    color:$color-secondary;
    font-size:1.2rem;
    font-weight:700;
    margin-bottom:1rem;
    padding-right:2rem;
    // -webkit-user-select:none;
	// user-select:none;
}
details > summary:hover {
    cursor: pointer;
}
details > summary::after {
    content: "";
    position: absolute;
    top: 0.2rem;
    right: 0;
    width: 22px;
    height: 22px;
    transition: transform var(--transition) ease-in;
    transform-origin: center center;
    line-height: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.783' height='8' viewBox='0 0 13.783 8'%3E%3Cpath id='down_arrow' data-name='down arrow' d='M32.843,44.579a1.076,1.076,0,0,0,1.529,0L40.2,38.747a1.082,1.082,0,0,0-1.53-1.53l-5.067,5.036-5.036-5.036a1.036,1.036,0,0,0-.764-.319.988.988,0,0,0-.765.319,1.1,1.1,0,0,0,0,1.53Z' transform='translate(-26.732 -36.898)'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
}
details > summary h4 {
    margin-bottom: 0;
    margin-right: 2rem;
}
.panel{
    padding:1px 0;
}
summary::-webkit-details-marker {
	display: none;
}
details:open summary::after {
    transform: rotate(180deg);
}
`;
export const containers = css `
    .container {
        position: relative;
        width: 100%;
        overflow: hidden;
        &:has(>allin-alt-block){
            overflow:visible;
            overflow-x:clip;
        }
    }

    @supports (aspect-ratio: 16/9) {
        .container.container--square {
            aspect-ratio: 1 / 1;
        }
        .container.container--sixteennine {
            aspect-ratio: 16 / 9;
        }
        .container.container--fourthree {
            aspect-ratio: 4 / 3;
        }
        .container.container--twentyonenine {
            aspect-ratio: 21 / 9;
        }
        .container.container--fivefour {
            aspect-ratio: 5 / 4;
        }
        .container.container--fourfive {
            aspect-ratio: 4 / 5;
        }
        .container.container--twothree {
            aspect-ratio: 2 / 3;
        }
        .container.container--threetwo {
            aspect-ratio: 3 / 2;
        }
    }

    @supports not (aspect-ratio: 16/9) {
        .container.container--square {
            padding-top: 100%;
            height: 0;
        }
        .container.container--sixteennine {
            padding-top: 56.25%;
            height: 0;
        }
        .container.container--fourthree {
            padding-top: 75%;
            height: 0;
        }
        .container.container--twentyonenine {
            padding-top: 42.85%;
            height: 0;
        }
        .container.container--fivefour {
            padding-top: 80%;
            height: 0;
        }
        .container.container--fourfive {
            padding-top: 125%;
            height: 0;
        }
        .container.container--twothree {
            padding-top: 150%;
            height: 0;
        }
        .container.container--threetwo {
            padding-top: 66%;
            height: 0;
        }
    }

    .container img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 50% 35%;
    }

    .cover img {
        width: 100%;
        height: auto;
    }
`;
export const sidebar = css `
    .sidebar.preview{
        margin-top:5rem;
    }

    .sidebar .grid--icon{
        grid-template-columns: 1.6rem 1fr;
        gap:1.5rem;
        border-bottom:1px solid var(--allin-border-color,#707070);
        padding:1rem 0;
    }
    .sidebar p{
        margin:0;
    }
    .sidebar  .grid--icon p strong,
    .sidebar  .grid--icon h3 strong{
        color:var(--allin-regular-text-color,#1a1a1a);
    }

    .sidebar  .grid--icon svg path{
        fill:var(--allin-highlight-color,#472961);
    }

    .sidebar  .grid--icon svg{
        width:1.6rem;
        height:auto;
    }

    .sidebar .item.text{
        padding:0 0 1rem;
    }

    .sidebar  .grid--icon+.item.text{
        padding-top:1rem;
    }

    .sidebar a{
        color:var(--allin-text-color,#472961);
        text-decoration:underline;
        font-weight:600;
    }

    .sidebar .item.text img{
        object-fit:contain;
    }

    .sidebar .item.text:last-child{
        border-bottom:1px solid var(--allin-border-color,#707070);
    }
`;
export const markdown = css `
    .milkdown {
        --crepe-color-background: #ffffff;
        --crepe-color-on-background: #000000;
        --crepe-color-surface: #f7f7f7;
        --crepe-color-surface-low: #ededed;
        --crepe-color-on-surface: #1c1c1c;
        --crepe-color-on-surface-variant: #4d4d4d;
        --crepe-color-outline: #000;
        --crepe-color-primary: var(--allin-highlight-color,#472961);
        --crepe-color-secondary: var(--color-secondary-to-secondary-lighter, #d3c9d7);
        --crepe-color-on-secondary: #000000;
        --crepe-color-inverse: #f0f0f0;
        --crepe-color-on-inverse: #1a1a1a;
        --crepe-color-inline-code: #ba1a1a;
        --crepe-color-error: #ba1a1a;
        --crepe-color-hover: var(--allin-bg-color, #ccc);
        --crepe-color-selected: var(--color-secondary-to-secondary-lighter, #d3c9d7);
        --crepe-color-inline-area: #cacaca;

        --crepe-font-title: var(--allin-font-family,inherit);
        --crepe-font-default: var(--allin-font-family,inherit);

        --crepe-shadow-1:
            0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3);
        --crepe-shadow-2:
            0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3);
    }

    .ProseMirror {
        position: relative;
    }

    .ProseMirror {
        word-wrap: break-word;
        white-space: pre-wrap;
        white-space: break-spaces;
        -webkit-font-variant-ligatures: none;
        font-variant-ligatures: none;
        font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
    }

    .ProseMirror pre {
        white-space: pre-wrap;
    }

    .ProseMirror li {
        position: relative;
    }

    .ProseMirror-hideselection *::selection { background: transparent; }
    .ProseMirror-hideselection *::-moz-selection { background: transparent; }
    .ProseMirror-hideselection { caret-color: transparent; }

    /* See https://github.com/ProseMirror/prosemirror/issues/1421#issuecomment-1759320191 */
    .ProseMirror [draggable][contenteditable=false] { 
        user-select: text;
    }

    .ProseMirror-selectednode {
        outline: 2px solid #8cf;
    }

    /* Make sure li selections wrap around markers */

    li.ProseMirror-selectednode {
        outline: none;
    }

    li.ProseMirror-selectednode:after {
        content: "";
        position: absolute;
        left: -32px;
        right: -2px; top: -2px; bottom: -2px;
        border: 2px solid #8cf;
        pointer-events: none;
    }

    /* Protect against generic img rules */

    img.ProseMirror-separator {
        display: inline !important;
        border: none !important;
        margin: 0 !important;
    }

    .milkdown .milkdown-block-handle[data-show='false'] {
        opacity: 0;
        pointer-events: none;
    }
    .milkdown .milkdown-block-handle {
        transition: all 0.2s;
        position: absolute;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2px;
    }
    .milkdown .milkdown-block-handle .operation-item {
        border-radius: 4px;
        width: 32px;
        height: 32px;
        padding: 4px;
    }
    .milkdown .milkdown-block-handle .operation-item svg {
        width: 24px;
        height: 24px;
        fill: var(--crepe-color-outline);
    }
    .milkdown .milkdown-block-handle .operation-item:hover {
        background: var(--crepe-color-hover);
    }
    .milkdown .milkdown-block-handle .operation-item.active {
        background: var(--crepe-color-selected);
    }
    .milkdown .milkdown-slash-menu[data-show='false'] {
        display: none;
    }
    .milkdown .milkdown-slash-menu {
        position: absolute;
        z-index: 10;
        display: block;
        font-family: var(--crepe-font-default);
        color: var(--crepe-color-on-surface);
        background: var(--crepe-color-surface);
        border-radius: 12px;
        box-shadow: var(--crepe-shadow-1);
    }
    .milkdown .milkdown-slash-menu ul {
        list-style-type: none;
    }
    .milkdown .milkdown-slash-menu ul li {
        cursor: pointer;
        border-radius: 8px;
    }
    .milkdown .milkdown-slash-menu .tab-group {
        border-bottom: 1px solid
            color-mix(in srgb, var(--crepe-color-outline), transparent 80%);
        padding: 12px 12px 0;
    }
    .milkdown .milkdown-slash-menu .tab-group ul {
        padding: 8px 10px;
        display: flex;
        gap: 10px;
        flex-wrap: nowrap;
    }
    .milkdown .milkdown-slash-menu .tab-group ul li {
        padding: 6px 10px;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .milkdown .milkdown-slash-menu .tab-group ul li:hover {
        background: var(--crepe-color-hover);
    }
    .milkdown .milkdown-slash-menu .tab-group ul li.selected {
        background: var(--crepe-color-selected);
        color:#fff;
    }
    .milkdown .milkdown-slash-menu .menu-groups {
        padding: 0 12px 12px;
        max-height: 420px;
        overflow: auto;
        overscroll-behavior: contain;
        scroll-behavior: smooth;
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group h6 {
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        padding: 14px 10px;
        text-transform: uppercase;
        color: color-mix(
        in srgb,
        var(--crepe-color-on-surface),
        transparent 40%
        );
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group li {
        min-width: 220px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;
        padding: 14px 10px;
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group li.hover {
        background: var(--crepe-color-hover);
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group li.active {
        background: var(--crepe-color-selected);
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group li svg {
        width: 24px;
        height: 24px;
        color: var(--crepe-color-outline);
        fill: var(--crepe-color-outline);
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group li > span {
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .milkdown .milkdown-slash-menu .menu-groups .menu-group + .menu-group::before {
        content: '';
        display: block;
        height: 1px;
        background: color-mix(
        in srgb,
        var(--crepe-color-outline),
        transparent 80%
        );
        margin: 0 10px;
    }
    .milkdown .milkdown-list-item-block {
        display: block;
        padding: 0;
    }

    .milkdown .milkdown-list-item-block > .list-item {
        display: flex;
        align-items: flex-start;
    }

    .milkdown .milkdown-list-item-block > .list-item > .children {
        min-width: 0;
        flex: 1;
    }

    .milkdown .milkdown-list-item-block li {
        gap: 10px;
    }

    .milkdown .milkdown-list-item-block li .label-wrapper {
        color: var(--crepe-color-outline);
    }

    .milkdown .milkdown-list-item-block li .label-wrapper svg {
        fill: var(--crepe-color-outline);
    }

    .milkdown .milkdown-list-item-block li .label-wrapper {
        height: 32px;
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .milkdown .milkdown-list-item-block li .label-wrapper .label {
        height: 32px;
        padding: 4px 0;
        width: 24px;
        text-align: right;
    }

    .milkdown .milkdown-list-item-block li .label-wrapper .checked,
    .milkdown .milkdown-list-item-block li .label-wrapper .unchecked {
        cursor: pointer;
    }

    .milkdown .milkdown-list-item-block li .label-wrapper .readonly {
        cursor: not-allowed;
    }
    .milkdown .crepe-placeholder::before {
        position: absolute;
        color: color-mix(
        in srgb,
        var(--crepe-color-on-background),
        transparent 60%
        );
        pointer-events: none;
        height: 0;
        content: attr(data-placeholder);
    }
    .milkdown:has(.milkdown-link-preview[data-show='true']) .milkdown-toolbar,
    .milkdown:has(.milkdown-link-edit[data-show='true']) .milkdown-toolbar {
        display: none;
    }
    .milkdown .milkdown-toolbar[data-show='false'] {
        display: none;
    }
    .milkdown .milkdown-toolbar {
        z-index: 10;
        position: absolute;
        display: flex;
        background: var(--crepe-color-surface);
        box-shadow: var(--crepe-shadow-1);
        border-radius: 8px;
        overflow: hidden;
    }
    .milkdown .milkdown-toolbar .divider {
        width: 1px;
        background: color-mix(
            in srgb,
            var(--crepe-color-outline),
            transparent 80%
        );
        height: 24px;
        margin: 10px;
    }
    .milkdown .milkdown-toolbar .toolbar-item {
        width: 32px;
        height: 32px;
        margin: 6px;
        padding: 4px;
        cursor: pointer;
        border-radius: 4px;
    }

    .milkdown .milkdown-toolbar .toolbar-item:not(:nth-child(1)):not(:nth-child(2)), .milkdown .milkdown-toolbar .divider{
        display:none;
    }

    .milkdown .milkdown-toolbar .toolbar-item:hover {
        background: var(--crepe-color-hover);

    }
    .milkdown .milkdown-toolbar .toolbar-item:active {
        background: var(--crepe-color-selected);
    }
    .milkdown .milkdown-toolbar .toolbar-item svg {
        height: 24px;
        width: 24px;
        color: var(--color-white);
        fill: var(--color-white);
    }
    .milkdown .milkdown-toolbar .toolbar-item.active svg, .milkdown .milkdown-toolbar .toolbar-item:hover svg {
        color: var(--crepe-color-primary);
        fill: var(--crepe-color-primary);
    }
    .milkdown .editor{
        min-height:10rem;
        background-color:var(--color-white);
        border:1px solid var(--allin-border-color,#707070);
        border-radius:var(--allin-border-radius,0.5rem);
        padding:1rem;
    }

    .readonly .milkdown .editor{
        min-height:fit-content;
        background-color:transparent;
        border:none;
        padding:0;
    }

    .milkdown .milkdown-block-handle[data-show='false'] {
      opacity: 0;
      pointer-events: none;
    }
    .milkdown .milkdown-block-handle {
    transition: all 0.2s;
    position: absolute;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
}
    .milkdown .milkdown-block-handle .operation-item {
      border-radius: 4px;
      width: 32px;
      height: 32px;
      padding: 4px;
    }
    .milkdown .milkdown-block-handle .operation-item svg {
        width: 24px;
        height: 24px;
        fill: var(--crepe-color-outline);
      }
    .milkdown .milkdown-block-handle .operation-item:hover {
        background: var(--crepe-color-hover);
      }
    .milkdown .milkdown-block-handle .operation-item.active {
        background: var(--crepe-color-selected);
      }
  .milkdown .milkdown-slash-menu[data-show='false'] {
      display: none;
    }
  .milkdown .milkdown-slash-menu {
    position: absolute;
    z-index: 10;
    display: block;
    font-family: var(--crepe-font-default);
    color: var(--crepe-color-on-surface);
    background: var(--crepe-color-surface);
    border-radius: 12px;
    box-shadow: var(--crepe-shadow-1);
}
  .milkdown .milkdown-slash-menu ul {
      list-style-type: none;
    }
  .milkdown .milkdown-slash-menu ul li {
        cursor: pointer;
        border-radius: 8px;
      }
  .milkdown .milkdown-slash-menu .tab-group {
      border-bottom: 1px solid
        color-mix(in srgb, var(--crepe-color-outline), transparent 80%);
      padding: 12px 12px 0;
    }
  .milkdown .milkdown-slash-menu .tab-group ul {
        padding: 8px 10px;
        display: flex;
        gap: 10px;
        flex-wrap: nowrap;
      }
  .milkdown .milkdown-slash-menu .tab-group ul li {
          padding: 6px 10px;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }
  .milkdown .milkdown-slash-menu .tab-group ul li:hover {
            background: var(--crepe-color-hover);
          }
  .milkdown .milkdown-slash-menu .tab-group ul li.selected {
            background: var(--crepe-color-selected);
          }
  .milkdown .milkdown-slash-menu .menu-groups {
      padding: 0 12px 12px;
      max-height: 420px;
      overflow: auto;
      overscroll-behavior: contain;
      scroll-behavior: smooth;
    }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group h6 {
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
          padding: 14px 10px;
          text-transform: uppercase;
          color: color-mix(
            in srgb,
            var(--crepe-color-on-surface),
            transparent 40%
          );
        }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group li {
          min-width: 220px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 16px;
          padding: 14px 10px;
        }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group li.hover {
            background: var(--crepe-color-hover);
          }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group li.active {
            background: var(--crepe-color-selected);
          }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group li svg {
            width: 24px;
            height: 24px;
            color: var(--crepe-color-outline);
            fill: var(--crepe-color-outline);
          }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group li > span {
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
          }
  .milkdown .milkdown-slash-menu .menu-groups .menu-group + .menu-group::before {
        content: '';
        display: block;
        height: 1px;
        background: color-mix(
          in srgb,
          var(--crepe-color-outline),
          transparent 80%
        );
        margin: 0 10px;
      }

    .milkdown .milkdown-toolbar .toolbar-item.active{
        background: var(--color-primary);
    }

    .milkdown ul {
        list-style: disc;
        padding-left: 1.5rem;
        li{
            display:list-item;
            margin-bottom:1rem;
        }
    }

    .milkdown{
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            color: #472961;
            font-weight: 400;
            line-height: 210%;
            margin: 0 0 1rem;
        }

        h2,.h2 {
            font-size: 1.8rem;
            font-weight: 700;
        }
    }

`;
